@if (showIsRequiredError) {
  <div class="required-text">*Påkrevd</div>
}
<div class="input-container">
  <input
    class="checkbox-input"
    type="checkbox"
    [attr.data-testid]="testId()"
    [formControl]="control"
    [id]="forId"
    [name]="name"
    [ngClass]="{
      checked: checked,
      disabled: disabled,
      'has-error': isErrorState,
    }"
    (keydown.enter)="toggleCheckbox($event)"
  />
  <label [for]="forId">
    {{ label }}
  </label>
</div>
@if (isErrorState && !!errorText) {
  <div class="error-section">
    <mat-icon [svgIcon]="IconNames.ice_warning" />
    <span>{{ errorText }}</span>
  </div>
}
